
const THICKNESS_OPTIONS = ['Super thin', 'Thin', 'Medium', 'Thick', 'Super thick'];

export default function ThicknessSelector({ value }) {
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center">
        {THICKNESS_OPTIONS.map((option) => (
          <div key={option} className="flex flex-col items-center w-full">
            <button
              type="button"
              className={`w-5 h-5 rounded-full border-2 ${
                value === option
                  ? 'bg-gray-700 border-gray-700'
                  : 'bg-white border-gray-300'
              }`}
            />
            <span className="text-xs mt-2 text-center">{option}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

